<template>
   <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
			<div class="container-post">
				<div class="form-modal">
					<div> 
						<div class="section-modal">
								<button  class="close btn--close" @click="back()"></button>
								<div class="wrapper">
										<p>Asset Type</p>
										<select class="select-css mg-top1" v-model="assetType">
												<option value="" disabled selected>Select type:</option>
												<!-- <option value="picture" >Picture</option>
												<option value="video">Video</option> -->
												<option value="embed">Embed</option>
										</select>
										<div class="mg-top" v-if="assetType">
												<div class="section-modal">
														<template v-if="assetType === 'picture'">
																<p>Upload Image</p>
																<input id="pictureUpload" type="file" accept="image/*" @change="onAddFile($event, 'picture')" hidden>
																<div class="mg-top1">
																	<div class="imgUpload" >
																		<img v-if="assetImgUrl" :src="assetImgUrl" alt="">
																	</div>
																	<button class="btn-upload mg-right mg-top1" @click="chooseFiles('picture')">Choose</button>
																</div>
														</template>
														<template v-if="assetType === 'video'">
															<p>Upload Video</p>
															<input id="videoUpload" type="file" accept="video/*" @change="onAddFile($event, 'video')" hidden>
															<div class="home-vid mg-top1">
																<video ref="video" v-if="videoUrl" :src="videoUrl" controls></video>
															</div>
															<button class="btn-upload mg-right mg-top1" @click="chooseFiles('video')">Choose</button>
														</template>
														<template v-if="assetType === 'embed'">
																<p v-if="urlEmbed">View Video</p>
																<div class="txt-center">
																		<iframe :src="urlEmbed" v-if="urlEmbed" class="mg-top1" frameborder="0"></iframe>
																</div>
																<div class="input-data mg-top">
																		<input type="text" required v-model="embed" @change="getIdUrl">
																		<div class="underline"></div>
																		<label>Embed Video</label>
																</div>
														</template>
														<div class="input-data mg-top">
																<input type="text" required v-model="title">
																<div class="underline"></div>
																<label>Title</label>
														</div>
														<p>*Notes <span style="color:red">Gunakan "###" untuk pemisah warna tulisan</span> ex: <span style="color:blue">Partai</span> ### <span style="color:red">Perindo</span></p>
														<div class="text-area mg-top">
																<textarea v-model="description" required></textarea>
																<div class="underline"></div>
																<label>Description</label>
														</div>
														<div class="mg-top">
																<label>Summary</label>
																<quill-editor
																		class="mg-top1"
																		v-model="summary"
																		:options="editorOption"
																		@change="onEditorChange($event)"
																/>
														</div>
												</div>
										</div>
								</div>
						</div>
					</div>        
					<div class="btn-heading">
						<p class="mg-top" v-if="errors.length">
								<b>Please correct the following error(s):</b>
								<ul>
										<li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
								</ul>
						</p>

						<button class="btn-add mg-top1" v-if="assetType" @click="validation(id != 0 ? 'update' : 'add')">
								<!-- Add Post -->
								{{id != 0? 'Update' : 'Add'}} Post
						</button>
					</div>     
				</div>
			</div>
    </div>
   </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';
// import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'

import 'vue2-datepicker/index.css';

import auth from '@/service/auth.js'

export default {
    name: "TentangGaleriForm",
    data() {
			return {
				isLoading: false,
				id: '',

				assetType: '',

				assetImage: null,
				assetImgUrl : null,

				assetVideo: null,
				videoUrl: null,

				description: '',
				title: '',
				summary: '',
				errors: [],
				// type: '',
				// picture: null,
				// embed: null,
				// video: null,
				embed: '',
				urlEmbed: '',
				editorOption: {},
				// event_date: '',
			}
    },
    methods: {
			convert(val) {
				let config = { inlineStyles: true }
				let converter = new QuillDeltaToHtmlConverter(val.ops, config)
				let html = converter.convert()
				this.descConvert = html
			},
			onEditorChange({ quill}) {
				this.convert(quill.editor.delta)
			},
			getIdUrl (e) {
					console.log('event', e)
					const url = e.target.value
					let id = ''

					if (url.includes('v=')) {
							id = url.split('v=')[1]
							console.log('url', url)
							this.urlEmbed = `https://www.youtube.com/embed/${id}`
					} else if (url.includes('youtu.be/')) {
							id = url.split('youtu.be/')[1]
							this.urlEmbed = `https://www.youtube.com/embed/${id}`
					} else {
							this.urlEmbed = url
					}

			},
			validation(type) {
					this.errors = []

					if (!this.title) this.errors.push('* Title required')
					if (!this.description) this.errors.push('* Description required')
					

					if (this.errors.length > 0) {
							return
					} else if (type === 'add') {
							this.addPerindo()
					} else if (type === 'update') {
							this.updatePerindo()
					}
			},
			async addPerindo() {
					const res = await auth.checkAuth(this.$route.fullPath)
					if (res == false) {
							localStorage.clear()
							alert.failed('Unauthorized Token', () => this.$router.push('/login'))
					} else {
							try { 
								this.isLoading = true
								const formData = new FormData()

								formData.append('type', 'embed')
								formData.append('asset_type', this.assetType)
								if (this.assetType == 'embed') {
									formData.append('embed', this.embed)
								} else {
									formData.append('asset', this.assetType == 'picture' ? this.assetImage : this.assetVideo)
								}
								formData.append('title', this.title)
								formData.append('description', this.description)
								formData.append('summary', this.descConvert)

								const response = await axios.post('/content/about', formData)
								this.isLoading = false

								console.log(response)
								if(response.status == 200) {
										alert.success('Add data success', () => this.$router.go(-1))
								}
	
							} catch (error) {
									console.log(error)
							}
					}
			},
			async updatePerindo() {
					const res = await auth.checkAuth(this.$route.fullPath)
					if (res == false) {
							localStorage.clear()
							alert.failed('Unauthorized Token', () => this.$router.push('/login'))
					} else {
							try { 
								this.isLoading = true
								const formData = new FormData()

								formData.append('type', 'embed')
								formData.append('asset_type', this.assetType)
								if (this.assetType == 'embed') {
									formData.append('embed', this.embed)
								} else {
									formData.append('asset', this.assetType == 'picture' ? this.assetImage : this.assetVideo)
								}
								formData.append('title', this.title)
								formData.append('description', this.description)
								formData.append('summary', this.descConvert)

								const response = await axios.patch(`/content/about/embed/${this.id}`, formData)
								this.isLoading = false

								console.log(response)
								if(response.status == 200) {
										alert.success('Update data success', () => this.$router.go(-1))
								}
	
							} catch (error) {
									console.log(error)
									this.isLoading = false
									alert.failed('Update data failed')
							}
					}
			},
			async getDataPerindo() { 
							let dataId = localStorage.getItem('dataPerindoById')
							
							let data = JSON.parse(dataId)
							
							this.type = data.about_type
							this.assetType = data.asset_type.String
							this.urlEmbed = `https://www.youtube.com/embed/${data.asset.String}`
							this.embed = `https://www.youtube.com/embed/${data.asset.String}` 
							this.title = data.title
							this.summary = data.summary.String
							this.descConvert = data.summary.String
							this.description = data.description
							this.assetImage = data.asset
							this.assetImgUrl = data.asset.String
							// this.description = data.description
			},
			onAddFile (e, type) {
				let splitName = e.target.files[0].name.split('.')
				let nameTemp = ''
				let typeFile = ''

				splitName.forEach((item, index) => {
						if (index == 0) {
								nameTemp = item
						} else if (index+1 != splitName.length) {
								nameTemp = nameTemp + '.' + item
						} else if (index+1 == splitName.length) {
								typeFile = '.' + item
						}
				});

				let date = moment().format('DD-MM-YYYY hh:mm:ss')
				let newName = `${nameTemp} ${date}${typeFile}`
				const myNewFile = new File([e.target.files[0]], newName, {type: e.target.files[0].type});

				if (type === 'video') {
					this.assetVideo =	myNewFile
					this.videoUrl = URL.createObjectURL(this.assetVideo)

				} else if (type === 'picture') {
					this.assetImage = myNewFile
					this.assetImgUrl = URL.createObjectURL(this.assetImage);
				}
			},
			chooseFiles(type) {
				if (type === 'video') {
					document.getElementById("videoUpload").click()
				} else if (type === 'picture') {
					document.getElementById("pictureUpload").click()
				}
			},
			back() {
					this.$router.go(-1)
			}
    },
    components: {
        Loader
    },
		computed: {
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    created() {
			this.id = this.$route.params.id
			if(this.id != 0) {
					this.getDataPerindo();
			}
    },   
}
</script>